import { forwardRef, Fragment, useEffect, useState } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { Autocomplete } from '@mui/material';
import { TextField } from "@mui/material";

const MuiAutoCompleteSelect = forwardRef((props, ref) => {
  const {
    label,
    name,
    options,
    variant,
    onChange,
    value,
    error,
    helperText,
    required,
    disabled,
  } = props;

  const [inputValue, setInputValue] = useState(null);
  useEffect(() => {
    if (!value) {
      setInputValue(null);
      return;
    }
    const option = options.find((o) => o.id === value);
    setInputValue(option);
  }, [options, value]);
  const handleChange = (data) => {
    setInputValue(data || null);
    onChange(data?.id || "");
  };
  return (
    <Autocomplete
      id={name}
      value={inputValue}
      options={options}
      onChange={(_e, data) => handleChange(data)}
      disabled={disabled}
      getOptionLabel={(option) => option.label}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant={variant}
          value={inputValue}
          error={error}
          helperText={helperText}
          required={required}
        />
      )}
    />
  );
});

function FormAutoComplete(props) {
  const { label, name, required, validate } = props;
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Fragment>
      <Controller
        as={MuiAutoCompleteSelect}
        control={control}
        name={name}
        label={label}
        defaultValue=""
        error={Boolean(errors[name])}
        helperText={errors[name]?.message}
        rules={{ required, validate }}
        {...props}
      />
    </Fragment>
  );
}

export default FormAutoComplete;
